import { Component } from '@theme/component';

class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
  }

  #formatTable(table) {
    const parent = table.parentElement;
    if (!parent) return;
    if (parent.matches('.rte-table-wrapper, .bs-article-table-scroll')) {
      parent.classList.add('rte-table-wrapper');
      parent.tabIndex = 0;
      return;
    }
    const wrapper = document.createElement('div');
    wrapper.className = 'rte-table-wrapper';
    wrapper.tabIndex = 0;
    parent.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}

